export const departmentListRoute = {
  path: "/management/department",
  name: "department-list",
  component: () => import("@/ui/management/department/department-list.vue")
};